export default {
    payMoney: '支付金额',
    CostName: '费用名称',
    UnitPrice: '单价',
    number: '数量',
    Subtotal: '小计',
    Deposit: '押金',
    isDeposit: '是否是押金',
    writeAnInvoice: '是否开发票',
    operation: '操作',
    remark: '备注',
    totalOfCostToBePaid: '待缴费用总计',
    totalOfCommodityrentalfees: '商品租赁费用总计',
    totalOfFixedCost: '固定费用总计',
    delete: '删除',
    addRemarks: '添加备注',
    Nameofpersonincharge: '负责人姓名',
    Contactnumber: '联系方式',
    ChoosePayment: '选择支付方式',
    feeSuccessful: '支付成功',
    OfflineRemittance: '转账汇款',
	'深圳市纸制品展览会':'深圳市纸制品展览会',
	'布展时间':'布展时间',
	'至':'至',
	'开展时间':'开展时间',
	'待缴费用':'待缴费用',
	'共':'共',
	'个展位':'个展位',
	'个展位费用': '个展位',
	'项费用':'项费用',
	'展位':'展位',
	'搭建商':'搭建商',
	'删除':'删除',
	'商品租赁':'商品租赁',
	'项租赁费用':'项租赁费用',
	'现场负责人':'现场负责人',
	'请输入负责人姓名':'请输入负责人姓名',
	'请输入正确的手机号码':'请输入手机号码',
	'请输入联系方式':'请输入联系方式',
	'请填写贵展位的现场负责人，对于订单的配送及异常状况的处理，我们的工作人员将联系该负责人，请如实填写，如因无法联系或者联系方式错误等原因造成的订单服务时效过长，我司概不负责':'请填写贵展位的现场负责人，对于订单的配送及异常状况的处理，我们的工作人员将联系该负责人，请如实填写，如因无法联系或者联系方式错误等原因造成的订单服务时效过长，我司概不负责',
	'订单总计':'订单总计',
	'元':'元',
	'上一步':'上一步',
	'提交订单':'提交订单',
	'添加备注':'添加备注',
	'请输入备注':'请输入备注...',
	'参展商':'参展商',


	//feePayment
	'订单列表':'订单列表',
	'订单号':'订单号',
  '支付方式':'支付方式',
	'联系方式':'联系方式',
	'微信支付':'微信支付',
	'支付宝支付':'支付宝支付',
	'线下汇款':'转账汇款',
  '云账单支付': '云账单支付',
	'如需公账付款，请选择支付宝或转账汇款':'如需公账付款，请选择支付宝、转账汇款或云账单支付。',
	'如需公账付款，请选择支付宝':'如需公账付款，请选择支付宝。',
	'不会支付宝公帐汇款？':'不会支付宝公帐汇款？',
	'确认支付':'确认支付',
  '提交订单':'提交订单',
  '押金支付':'押金支付',
  '费用支付':'费用支付',
  '支付成功':'支付成功',
  '押金订单':'订单类型：押金订单',
  '费用订单':'订单类型：费用订单',
  '请选择支付方式':'请选择支付方式！',
	'请在':'请在',
	'分':'分',
	'秒内支付完成':'秒内支付完成',
	'支付方式选择提示':'支付方式选择提示',
	'您选择通过':'您选择通过',
	'进行支付':'进行支付，确认后将无法更改支付方式，请确认',
  '提示':'提示',
  '提示内容':'必须先缴纳押金后，方可进行商品费用支付',
	'支付方式已选择':'支付方式已选择！',
	'返回订单中心':'返回订单中心',
	'支付失败':'支付失败',
	'网络出错':'网络出错，请重试',
	'待支付': '待支付',
	'已退款': '已退款',
	'已取消': '已取消',
	'已完成': '已完成',
	'已失效': '已失效',
	'已出保单': '已出保单',
	'出单失败': '出单失败',
	'已退保': '已退保',
	'支付订单':'支付订单',
	'联系人姓名':'联系人姓名',
	'联系电话':'联系电话',
	'订单详情':'订单详情',
	'展位号':'展位号',
	'金额':'金额',
	'状态':'状态',
	'创建时间':'创建时间',
	'名称':'名称',
	'订单提交成功':'订单提交成功',
	'共生成':'共生成',
	'笔订单':'笔订单',
	'请尽快付款':'请尽快付款',
	'您已选择支付方式或订单已支付，请勿重复提交！':'您已选择支付方式或订单已支付，请勿重复提交！',
	'查看订单详情':'查看订单详情',

	//feeSuccessful
	'支付成功':'支付成功',
	'秒后将为您跳转到':'秒后将为您跳转到',
	'订单中心':'订单中心',
	'返回':'返回',
	'信息':'信息',
	'确定删除该费用吗':'确定删除该费用吗?',
	'提交失败':'提交失败',
	'订单为空':'订单为空，无法提交订单',
	'网络出错':'网络出错，请重试!',
	'确定':'确定',
	'取消':'取消',

	'填写并核对订单信息':'填写并核对订单信息',
	'返回修改租赁商品':'返回修改租赁商品',
	'返回展位费用选择':'返回展位费用选择',
	'联系电话':'联系电话',
	'联系人信息':'联系人信息',
	'请输入备注':'请输入备注'
  }



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/feeConfirmation.js